// extracted by mini-css-extract-plugin
export default {"table":"TablesReports_table__8RsMS","task-url":"TablesReports_task-url__clDlP"};